import { useState } from "react";
import { useTranslation } from "react-i18next";

import { Button } from "@/components/Button/Button";
import { ButtonColor, ButtonSize } from "@/components/Button/types";
import { usePageTitle } from "@/utils/usePageTitle";

import { useGetTaskTemplatesQuery } from "../../redux/task-template/task-template.api";
import { TaskTemplateInfo } from "./schema/task-template";
import { TaskTemplateTable } from "./components/TaskTemplateTable";
import { TaskTemplateModal } from "./components/TaskTemplateModal";

export default function ManageTaskTemplates() {
	const { t } = useTranslation();
	const ts = (key: string) => t(`manage-task-templates.${key}`);

	const { data: templates = [], isLoading } = useGetTaskTemplatesQuery();

	const [isModalOpen, setIsModalOpen] = useState(false);
	const [editingTemplate, setEditingTemplate] = useState<TaskTemplateInfo | null>(null);

	usePageTitle(ts("title"));

	const handleCreate = () => {
		setEditingTemplate(null);
		setIsModalOpen(true);
	};

	const handleEdit = (template: TaskTemplateInfo) => {
		setEditingTemplate(template);
		setIsModalOpen(true);
	};

	const handleCloseModal = () => {
		setIsModalOpen(false);
		setEditingTemplate(null);
	};

	return (
		<div className="p-6">
			<div className="flex items-center justify-between mb-6">
				<h1 className="text-2xl font-bold text-primary-gray">{ts("title")}</h1>
				<Button
					color={ButtonColor.BRAND}
					size={ButtonSize.M}
					title={ts("add-template")}
					type="button"
					onClick={handleCreate}
				/>
			</div>

			<TaskTemplateTable
				isLoading={isLoading}
				templates={templates}
				onEdit={handleEdit}
			/>

			<TaskTemplateModal
				isOpen={isModalOpen}
				template={editingTemplate}
				onClose={handleCloseModal}
			/>
		</div>
	);
}

